import type { ReactNode } from 'react';

/**
 * One card on a personal settings page, named by a heading inside it (spec 142;
 * shared since spec 158 gave the settings a second page).
 */
export function SettingsPanel({
  labelledBy,
  children,
}: {
  labelledBy: string;
  children: ReactNode;
}) {
  return (
    <section
      aria-labelledby={labelledBy}
      className="border-border bg-card flex flex-col gap-4 rounded-xl border p-4 sm:p-5"
    >
      {children}
    </section>
  );
}
